export class Address {
    constructor(
        public Number: string,
        public Street: string,
        public Locality: string,
        public PostCode: string,
        public County: string,
        public Country: string) { }
}
